import React from "react";
import { withTranslation } from "react-i18next";
import i18n from '../../i18n';

import { getLoggedUser } from "../auth/Signin";
import UserFavorites from "./UserFavorites";
import Title from "../Structure/logo";
export var navigator = undefined;
export var updateUser = undefined;

class Home extends React.Component {
  constructor() {
    super();
    this.state = {
      data: [],
      user: "",
      permChanged: "notyet",
      widgets: [],
      plates: []
    }
    updateUser = this.updateHome;
  }

  render() {
    return (
      <div>
        <div className="component-body">
          <Title icon="home" text={i18n.t("hello") + " " + getLoggedUser()} />
          <UserFavorites redraw={this.state.permChanged} />
        </div>
      </div>
    )
  }
}

export default withTranslation()(Home);
